{
  "en": {
    "classroomScreen": {
      "buttons": {
        "annotate": "Draw",
        "cardActions": "Card actions",
        "clearAllDrawings": "Clear all drawings",
        "eraser": "Eraser",
        "pencil": "Pencil",
        "marker": "Marker",
        "continue": "Continue",
        "createQrCode": "Create QR code",
        "customTime": "Different timer",
        "delete": "Delete",
        "deleteCard": "Delete card",
        "drawTicket": "Draw lottery ticket",
        "duplicate": "Duplicate",
        "embed": "Embed",
        "fifteenMinutes": "15 minutes",
        "fiveMinutes": "5 minutes",
        "green": "Green light",
        "groupMode": "Work in groups",
        "groupShuffle": "Shuffle groups",
        "insertTool": "Insert tool",
        "moveToPage": "Page {page}",
        "partnerMode": "Work in pairs",
        "pause": "Pause",
        "plenumMode": "Class discussion",
        "red": "Red light",
        "reset": "Reset",
        "resetTickets": "Put all tickets back",
        "rollDice": "Roll dice",
        "showVideo": "Show video",
        "silenceMode": "Work on your own",
        "start": "Start",
        "stop": "Stop",
        "submitList": "List complete",
        "tenMinutes": "10 minutes",
        "uploadFile": "Upload file",
        "viewInSpotlight": "View in spotlight mode",
        "yellow": "Yellow light"
      },
      "components": {
        "dice": "Dice",
        "embed": "Embed",
        "file": "File",
        "group": "Group",
        "image": "Image",
        "internalTool": "Tool",
        "lottery": "Lottery",
        "qrcode": "Link",
        "stoplights": "Traffic Lights",
        "stopwatch": "Stopwatch",
        "text": "Text",
        "timer": "Timer",
        "video": "Video",
        "watch": "Watch",
        "workMode": "Social form"
      },
      "confirm": {
        "deleteCard": {
          "title": "Delete card?",
          "text": "This action cannot be undone. All content of the current card will be permanently removed."
        },
        "deletePage": {
          "title": "Delete current page?",
          "text": "This action cannot be undone. All content of the current page will be permanently removed."
        },
        "clearCanvas": {
          "title": "Remove all drawings?",
          "text": "This action cannot be undone. All drawings on the current page will be permanently removed."
        }
      },
      "flash": {
        "pageAdded": "Page added",
        "pageDeleted": "Page deleted",
        "pageUpdated": "Page updated",
        "cardUpdateFailed": "Change could not be saved",
        "cardDeleteFailed": "Card could not be deleted",
        "cardCreateFailed": "Card could not be created",
        "pageCreateFailed": "Page could not be created",
        "pageDeleteFailed": "Page could not be deleted",
        "pageReorderFailed": "Order could not be saved",
        "canvasSaveFailed": "Drawing could not be saved",
        "saving": "Saving…"
      },
      "headings": {
        "classroomScreen": "Teaching Board",
        "group": "Group",
        "minScreenWidth": "Please open the teaching board on a tablet or laptop"
      },
      "hints": {
        "embedCard": "Use the tools module to embed tools materials. In this way, when you copy this board, a new version of the integrated materials will be created automatically.",
        "itemId": "A new version of your integrated material will automatically be created if you duplicate this board. This allows you to easily reuse an existing lesson for another target group.",
        "itemType": "Allow others to access the shared content in the privacy settings so it can be displayed properly.",
        "maxLengthTitle": "The maximum length of the title is 45 characters.",
        "minScreenWidth": "To view the teaching board, you need a resolution of at least <strong>768&nbsp;pixels</strong> wide.",
        "noTicketsLeft": "No tickets left!"
      },
      "labels": {
        "diceCount": "Number of dice",
        "embed": "URL or iframe snippet",
        "embedInternal": "Show preview",
        "groupCount": "Number of groups",
        "groupMode": "Work in groups",
        "groupSize": "Number of people in a group",
        "itemId": "Title",
        "itemType": "Tool",
        "minutes": "Minutes",
        "partnerMode": "Work in pairs",
        "plenumMode": "Class discussion",
        "qrcodeInternal": "Insert QR code",
        "seconds": "Seconds",
        "shuffleCondition": "Shuffle groups according to",
        "silenceMode": "Work on your own",
        "start": "Start",
        "title": "Title for your card",
        "continue": "Continue",
        "pause": "Pause"
      },
      "placeholders": {
        "enterItems": "One name, number or word per row, for example:\nMax\nMoritz",
        "enterText": "Enter text…",
        "enterUrl": "Enter URL…",
        "enterUrlOrSnippet": "Enter URL oder iFrame snippet…",
        "enterVideoUrl": "Enter YouTube or Vimeo URL…",
        "names": "One name per row, for example:\nMax\nMoritz",
        "title": "Title...",
        "typeName": "Type name..."
      },
      "validations": {
        "itemLocked": "Because of the setup of this content, only the author can see it. Please contact him/her to change this setting."
      },
      "tooltips": {
        "editMode": "Edit",
        "drawMode": "Draw"
      },
      "viewModes": {
        "tool": "Tool mode",
        "canvas": "Draw mode"
      }
    },
    "schoolClass": {
      "classroom": {
        "labels": {
          "activateControls": {
            "stop": "stop"
          }
        }
      }
    }
  }
}
